import { type ClassValue, clsx } from "clsx";
import { Room } from "livekit-client";
import { twMerge } from "tailwind-merge";
import {
  type ReceivedChatMessage,
  type TextStreamData,
} from "@livekit/components-react";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function transcriptionToChatMessage(
  textStream: TextStreamData,
  room: Room,
): ReceivedChatMessage {
  return {
    id: textStream.streamInfo.id,
    timestamp: textStream.streamInfo.timestamp,
    message: textStream.text,
    from:
      textStream.participantInfo.identity === room.localParticipant.identity
        ? room.localParticipant
        : Array.from(room.remoteParticipants.values()).find(
            (p) => p.identity === textStream.participantInfo.identity,
          ),
  };
}
